import { useQuery } from '@tanstack/react-query';
import { getInvoiceDocuments } from '../Services/ProcessedTimesheetService';

const useGetInvoiceDocuments = (params, options) =>
    useQuery({
        queryKey: ['getInvoiceDocuments', params],
        queryFn: () => getInvoiceDocuments(params),
        enabled: !!params?.processedTimesheetId,
        ...options,
    });

export default useGetInvoiceDocuments;
